var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');

var getPeopleStructure = require('./PeopleStructure');


module.exports = Backbone.View.extend({

	events: {
		'click .dropdown span': 'handleClick',
		'change select': 'handleChange',
	},

	initialize: function() {
		this.listenTo(this.model, "change", this.render);
		this.focusNextRender = null;
	},

	render: function() {
		var model = this.model;

		this.lastRenderStructure = getPeopleStructure(this.model);
		this.el.innerHTML = TemplateCache.render('reserva-people-template', {
			items: this.lastRenderStructure,
			model: model,
		});

		if ( this.focusNextRender ) {
			this.$el.find('select[name="' + this.focusNextRender + '"]').focus();
			this.focusNextRender = null;
		}
	},

	handleClick: function(e) {
		e.preventDefault();
		var link = $(e.currentTarget);
		var parent = link.parents('.dropdown');

		this.model.set(parent.data('key'), link.data('value'));
	},

	handleChange: function(e) {
		var select = e.currentTarget;
		var key = select.name;
		var oldValue = this.model.get(key);
		var newValue = select.options[select.selectedIndex].value;

		/* This hack is needed for a race condition when new options appear after changing the values */
		this.model.attributes[key] = newValue;

		var takeNext = false;
		for(var i = 0, item; item = this.lastRenderStructure[i]; ++i) {
			if ( takeNext && item.type === "select" && item.condition(this.model) ) {
				this.focusNextRender = item.key;
				break;
			}
			if ( item.key == select.name ) {
				takeNext = true;
			}
		};

		this.model.attributes[key] = oldValue;
		this.model.set(select.name, select.options[select.selectedIndex].value);
	},

});



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/engine/views/PeopleView.js
 **/